import React, { useCallback, useEffect, useRef } from 'react'
import { CSVLink } from 'react-csv'
import PropTypes from 'prop-types'
import { confirmationAlert } from '../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'
import { thousandSeparator } from '../../utility/Helpers'

const DownloadCSV = (data) => {
  const { getData, filter, loading } = data
  const MAX_EXPORT_ROWS = 1000
  const csvLink = useRef()
  const { t } = useTranslation()

  const handelDownload = useCallback(() => {
    if (!loading) getData()
  }, [loading])

  useEffect(() => {
    if (filter.download?.data?.length > 0) csvLink?.current?.link.click()
  }, [filter])

  const valueFormatter = (original_value) => {
    let value = `${thousandSeparator(original_value)}`
    return value
  }

  return (
    <>
      <button
        disabled={loading}
        type="link"
        onClick={async () => {
          if (!loading) {
            await confirmationAlert({
              message:
                t('message.export_more_than_the_maximum') + ' ' + valueFormatter(MAX_EXPORT_ROWS),
              icon: 'question',
            }).then((confirm) => {
              if (confirm === true) {
                handelDownload()
                return
              }
            })
          } else {
            handelDownload()
          }
        }}
        className="btn btn-primary btn-xs text-nowrap px-2 py-1 mb-3"
      >
        {' '}
        {loading ? (
          t('title.loading')
        ) : (
          <>
            <i className="fa fa-download" /> {t('button.download_csv')}
          </>
        )}
      </button>
      {filter?.download?.data?.length > 0 && (
        <CSVLink
          data={filter?.download?.data}
          headers={filter?.download?.headers}
          filename={filter?.download?.filename}
          separator=";"
          uFEFF={false}
          ref={csvLink}
          target="_blank"
          enclosingCharacter={``}
        />
      )}
    </>
  )
}

DownloadCSV.propTypes = {
  filter: PropTypes.any,
  loading: PropTypes.bool,
  getData: PropTypes.func,
}

export default DownloadCSV
